/* ============================================================================
   GSC Review Snippets Fix  —  kingz.com  (Method A support layer)
   ----------------------------------------------------------------------------
   Google error fixed: Review snippets → Missing field "itemReviewed".

   Root cause: review apps (Judge.me, Okendo, Loox, Yotpo, Stamped) inject a
   standalone AggregateRating / Review as *microdata* (or a bare JSON-LD node)
   on star badges. When that rating is NOT nested inside a Product, Google has
   nothing to attach it to and reports "Missing field itemReviewed".

   Strategy:
   1. The valid, Google-approved rating now lives INSIDE the Product JSON-LD
      (snippet: product-auto.liquid — aggregateRating nested in Product).
   2. This script removes the *duplicate/orphaned* microdata + bare JSON-LD
      rating nodes that review apps add, so only the clean Product schema
      remains. Visible star badges (plain DOM, no schema attrs) are untouched.

   Non-destructive: for orphaned microdata we strip only the schema ATTRIBUTES
   (itemscope / itemtype / itemprop) — the visible stars/text stay on screen,
   Google just stops reading them as an orphaned review entity.
   ========================================================================== */
(function () {
  'use strict';

  // Known hidden rich-snippet containers that apps render purely for SEO.
  // These carry no visible UI, so it is safe to remove the whole node.
  var HIDDEN_SNIPPET_SELECTORS = [
    '.jdgm-prev-badge__rich-snippet',   // Judge.me
    '.oke-sr-rating[itemprop]',         // Okendo (defensive)
    '.loox-rating[itemprop]',           // Loox (defensive)
    '.yotpo-sr-bottom-line-summary[itemprop]' // Yotpo (defensive)
  ];

  // Any element that declares a review/rating microdata entity.
  var MICRODATA_SELECTOR = [
    '[itemtype*="AggregateRating"]',
    '[itemtype*="schema.org/Review"]',
    '[itemprop="aggregateRating"]',
    '[itemprop="review"]',
    '[itemprop="reviewCount"]',
    '[itemprop="ratingValue"]',
    '[itemprop="ratingCount"]',
    '[itemprop="reviewRating"]'
  ].join(',');

  function isInsideProduct(el) {
    return !!(el.closest && el.closest('[itemtype*="Product"]'));
  }

  function stripSchemaAttrs(el) {
    el.removeAttribute('itemscope');
    el.removeAttribute('itemtype');
    el.removeAttribute('itemprop');
  }

  function cleanOrphanRichSnippets() {
    try {
      // 1) Remove app-specific hidden SEO-only snippet containers entirely.
      HIDDEN_SNIPPET_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!isInsideProduct(el) && el.parentNode) {
            el.parentNode.removeChild(el);
          }
        });
      });

      // 2) Neutralize any remaining orphaned rating/review microdata
      //    (rating not nested inside a Product). Keeps visible UI intact.
      document.querySelectorAll(MICRODATA_SELECTOR).forEach(function (el) {
        if (!isInsideProduct(el)) {
          stripSchemaAttrs(el);
          // also clear schema attrs on descendants of an orphaned entity
          el.querySelectorAll('[itemprop],[itemscope],[itemtype]').forEach(stripSchemaAttrs);
        }
      });

      // 3) Remove bare standalone JSON-LD rating/review blocks that lack
      //    itemReviewed (apps that inject JSON-LD client-side).
      document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
        var txt = s.textContent || '';
        if (!/AggregateRating|"@type"\s*:\s*"Review"/.test(txt)) return;
        var data;
        try { data = JSON.parse(txt); } catch (e) { return; }
        var nodes = Array.isArray(data) ? data : [data];
        var offending = nodes.some(function (n) {
          if (!n || typeof n !== 'object') return false;
          var t = n['@type'];
          var isRatingRoot = t === 'AggregateRating' || t === 'Review' ||
            (Array.isArray(t) && (t.indexOf('AggregateRating') > -1 || t.indexOf('Review') > -1));
          return isRatingRoot && !n.itemReviewed;
        });
        if (offending && s.parentNode) s.parentNode.removeChild(s);
      });
    } catch (e) { /* fail silent — never break the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanOrphanRichSnippets);
  } else {
    cleanOrphanRichSnippets();
  }

  // Insurance: review apps often inject badges asynchronously after load.
  try {
    var mo = new MutationObserver(function () { cleanOrphanRichSnippets(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // Run for a while to catch late async widgets, then stop to save CPU.
    setTimeout(function () { mo.disconnect(); cleanOrphanRichSnippets(); }, 15000);
  } catch (e) { /* MutationObserver unsupported — one-shot clean already ran */ }
})();
